import { render, staticRenderFns } from "./ProviderRules.vue?vue&type=template&id=3865753e&lang=pug&"
import script from "./ProviderRules.vue?vue&type=script&lang=js&"
export * from "./ProviderRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports